'use client'

import { MinusIcon, PlusIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

/** The 1px column rule between an order field's segments (input | unit | stepper). */
export function OrderFieldDivider() {
  return <span className="bg-foreground/10 h-full w-px shrink-0" />
}

/**
 * The +/− column at the right end of an amount field — the same look as the limit price
 * field's (limit-price-field.tsx): the field itself has no fill, only this column is tinted.
 * On touch the two sit side by side (− | +) at full height instead of two 18px halves stacked.
 */
export function OrderFieldStepper({
  onIncrement,
  onDecrement,
  disabled,
  decrementDisabled,
  iconClassName = 'text-foreground/60',
}: {
  onIncrement: () => void
  onDecrement: () => void
  disabled?: boolean
  decrementDisabled?: boolean
  iconClassName?: string
}) {
  return (
    <div className="bg-foreground/5 flex shrink-0 flex-col self-stretch pointer-coarse:flex-row-reverse">
      <button
        type="button"
        tabIndex={-1}
        onClick={onIncrement}
        disabled={disabled}
        className="hover:bg-foreground/10 pointer-coarse:border-foreground/10 flex w-8 flex-1 items-center justify-center transition-colors not-disabled:cursor-pointer disabled:opacity-50 pointer-coarse:w-9 pointer-coarse:border-l"
      >
        <PlusIcon className={cn('size-3', iconClassName)} />
      </button>
      <button
        type="button"
        tabIndex={-1}
        onClick={onDecrement}
        disabled={disabled || decrementDisabled}
        className="border-foreground/10 hover:bg-foreground/10 flex w-8 flex-1 items-center justify-center border-t transition-colors not-disabled:cursor-pointer disabled:opacity-50 pointer-coarse:w-9 pointer-coarse:border-t-0"
      >
        <MinusIcon className={cn('size-3', iconClassName)} />
      </button>
    </div>
  )
}
